import i18n from 'i18next';

import showToast from '@/utils/helpers/show-toast';

const NETWORK_TOAST_ID = 'network-status-toast';

const toastDetailsMapper = () => ({
  error: {
    variant: 'error',
    title: i18n.t('network.offline'),
    options: {
      duration: Infinity,
      id: NETWORK_TOAST_ID,
    },
  } as const,
  success: {
    variant: 'success',
    title: i18n.t('network.restored'),
    options: {
      duration: 3000,
      id: NETWORK_TOAST_ID,
    },
  } as const,
});

const getNetworkStatusMessage = (status?: string) => {
  if (status === 'idle' || !status) {
    return;
  }

  if (status === 'offline') {
    showToast(toastDetailsMapper().error);
  }

  if (status === 'restored') {
    showToast(toastDetailsMapper().success);
  }

  return null;
};

export default getNetworkStatusMessage;
